<template>
    <a-modal 
        v-model="visible" 
        :title="$t('modal.change-password-title')" 
        :closable="false" 
        :ok-text="$t('modal-btn.alter-confirm-btn-caption')" 
        :cancel-text="$t('modal-btn.alter-cancel-btn-caption')" 
        @ok="handleOk" 
        @cancel="handleCancel"
    >
        <a-form
        id="components-form-demo-normal-login"
        class="login-form"
        :hideRequiredMark="true"
        >
            <a-form-item 
                class="mb-10" 
                :label="$t('form-label.old-password')"
                :colon="false"
                :validate-status="validations.statusOldPassword"
                :help="validations.helpOldPassword"
            >
                <a-input
                    class="form-input"
                    :placeholder="$t('form-placeholder.old-password')"
                    v-model="oldPassword"
                >
                </a-input>
            </a-form-item>

            <a-form-item 
                class="mb-5" 
                :label="$t('form-label.new-password')"
                :colon="false"
                :validate-status="validations.statusNewPassword"
                :help="validations.helpNewPassword"
            >
                    <!-- type="password" -->
                <a-input
                    class="form-input"
                    :placeholder="$t('form-placeholder.new-password')"
                    v-model="newPassword"
                >
                </a-input>
            </a-form-item>
            <a-form-item 
                class="mb-5" 
                :label="$t('form-label.confirm-password')"
                :colon="false"
                :validate-status="validations.statusConfirmPassword"
                :help="validations.helpConfirmPassword"
            >
                    <!-- type="password" -->
                <a-input
                    class="form-input"
                    :placeholder="$t('form-placeholder.confirm-password')"
                    v-model="confirmPassword"
                >
                    <!-- v-model="password" -->
                </a-input>
            </a-form-item>
        </a-form>
    </a-modal>
</template>

<script>
import { authClient } from "../../api/config.js";
import { toastMixin } from "../../mixins/ToastMixin.js";
export default {
    name: "ChangePasswordModal",
    mixins: [ toastMixin ],
    props: {
        // visible: {
        //     type: Boolean,
        //     required: true,
        // }
    },
    data(){
        return {
            oldPassword: "",
            newPassword: "",
            confirmPassword: "",
            validations: {
                statusOldPassword: "",
                helpOldPassword: "",
                statusNewPassword: "",
                helpNewPassword: "",
                statusConfirmPassword: "",
                helpConfirmPassword: "",
            },
            visible: false,
        }
    },
    methods:{
        showModal() {
            this.visible = true;
        },
        handleCancel(){
            this.visible = false;
        },
        clearValidations() {
            Object.keys(this.validations).forEach(key => {
                this.validations[key] = '';
            });
        },
         validate() {

            this.clearValidations();

            // if (this.password.trim().length == 0 && this.confirmPassword.trim().length == 0) {
            //     return true;
            // }
            
            if (this.newPassword.trim().length < 6) {
                this.validations.statusNewPassword = 'error';
                this.validations.helpNewPassword = this.$t('error-message.password');
                return false;
            }

            if (this.confirmPassword !== this.newPassword) {
                this.validations.statusNewPassword = 'error';
                this.validations.helpNewPassword = this.$t('error-message.confirm-new-password');
                this.validations.statusConfirmPassword = 'error';
                this.validations.helpConfirmPassword = this.$t('error-message.confirm-new-password');
                return false;
            }

            return true;

        },
        handleOk(e) {
            console.log(e);
            
            if (this.validate()) {
                let submitData = {
                    'oldPassword': this.oldPassword,
                    'newPassword': this.newPassword
                };
                authClient.changePassword(submitData).then(res => {
                    if (!res.networkError) {
                        if (res.status == 200) {
                            this.$emit("closeChangePasswordModal","");
                            this.visible = false;
                            this.newPassword = '';
                            this.confirmPassword = '';
                            this.oldPassword = '';
                            this.successToast(this.$t('toast-success-messages.password-change'));
                        } else {
                            this.errorToast(this.$t('toast-error-messages.error'));
                        }

                    } else {
                        this.errorToast(this.$t('toast-error-messages.network-error'));
                    }
                }).catch(error => {
                    console.log(error);
                    this.errorToast(this.$t('toast-error-messages.error'));
                })
            }
        },
    }
}
</script>

<style>

</style>